import * as turf from './turf';

export const featureCollectionToTurfPolygons = (featureCollection, homeMarkerGeoJson = null) => {
    const turfPolygons = [];
    featureCollection.features.forEach(feature => {
        const polygon = feature.geometry.type === 'GeometryCollection' ? turf.multiPolygon(feature.geometry.geometries.map(g => g.coordinates)) : turf.polygon(feature.geometry.coordinates);
        turfPolygons.push({
            polygon,
            feature: {
                ...feature,
                properties: {
                    homeMarkerGeoJson,
                    ...feature.properties,
                    area: turf.area(polygon)
                }
            }
        });
    });

    return turfPolygons;
};